exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.youtube-policy-cell-label[data-v-5bf40458] {\n  font-size: 12px;\n  color: #666;\n  width: 80px;\n  text-align: right;\n}\n.youtube-policy-cell-value[data-v-5bf40458] {\n  font-size: 12px;\n  color: #333;\n  width: 50px;\n  text-align: right;\n}\n\n", ""]);

// exports
